import { render, staticRenderFns } from "./DocumentPopup.vue?vue&type=template&id=1f79a0f6&"
import script from "./DocumentPopup.vue?vue&type=script&lang=js&"
export * from "./DocumentPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports